// extracted by mini-css-extract-plugin
export default {"error":"ErrorBoundary_error__3P3qB"};